// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__Q3PLM","container__menu":"main_container__menu__Oi8eq"};